import * as React from 'react';
import Modal from '../../../Modal';

export const MORE_FILTERS_MODAL = 'moreFiltersModal';

interface MoreFiltersModalProps {
  content: React.ReactNode;
}

export const MoreFiltersModal = (props: MoreFiltersModalProps) => {
  const { content } = props;

  return (
    <Modal name={MORE_FILTERS_MODAL} closeOnUnmount={false} caption="generic.filters">
      {content}
    </Modal>
  );
};
